import TableSkeletonGiveaway from './tableSkeletonGiveaway';
import TableSkeletonTalkingPoint from './tableSkeletonTalkingPoint';

const TableSkeleton = ({ selectedTab }) => {
  switch (selectedTab) {
    case 'talkingPoint':
      return <TableSkeletonTalkingPoint />;

    case 'giveaway':
      return <TableSkeletonGiveaway />;

    default:
      return <TableSkeletonTalkingPoint />;
  }
};

export default TableSkeleton;
